import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './pack/en'
import cn from './pack/cn'
import kh from './pack/kh'
Vue.use(VueI18n)
 
/* const messages = {
  'en-US': en,
  'km-KH': kh,
} */
 const messages = {
  'en-US': en,
  'zh-CN': cn,
  'km-KH': kh,
} 
 
const i18n = new VueI18n({
  locale:  sessionStorage.getItem('changeLang') || 'en-US',//从sessionStorage中拿到用户的语言选择，如果没有，那默认中文。
  messages,
  silentTranslationWarn: true,
})

i18n: (key, value) => i18n.t(key, value)

 
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js